"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ModalTitle_1 = require("./ModalTitle");
exports.default = ModalTitle_1.default;
//# sourceMappingURL=index.js.map